/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';

// Components
import ResourcesFeaturedDownloadComp from '../../components/resourcesFeaturedDownload';

export interface ResourcesFeaturedDownloadProps extends Section {
  image: {
    alternativeText: string;
    image: ImageType;
  };
  cta: CTA;
  text: {
    content: string;
  };
  title: {
    title: string;
  };
  backgroundImage: {
    backgroundImage: ImageType;
  };
}

const ResourcesFeaturedDownload: SectionComponent<ResourcesFeaturedDownloadProps> = React.memo(
  ({ title, image, cta, text, backgroundImage }) => (
    <ResourcesFeaturedDownloadComp
      title={title.title}
      bodyText={text.content}
      cta={cta}
      image={image.image}
      sx={{
        marginBottom: ['75px', '145px'],
      }}
      backgroundImage={backgroundImage.backgroundImage}
    />
  ),
);

export default ResourcesFeaturedDownload;
